import { InspectionResource } from 'modules/inspection/Resources';
import { ProductResource } from 'modules/product/Resources';
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';

const MICRO_PREFIX = `${ApiV1Base}${ApiPrefixV1}/micro`;
export const MICRO_RESOURCES = [
  {
    name: 'service-providers',
  },
  {
    name: 'suppliers',
  },
  // #region Document Lists
  {
    name: 'document-list',
    download: '/document-list/download',
  },
  {
    name: 'document-list/types',
  },
  {
    name: 'document-list/document-list-index',
  },
  {
    name: 'document-list-compliance-test-data',
    list: '/document-list/:id/compliance-data/test-data',
  },
  {
    name: 'document-list-compliance-certificate-data',
    list: '/document-list/:id/compliance-data/certificate-data',
  },
  {
    name: 'document-list-compliance-other-data',
    list: '/document-list/:id/compliance-data/other-data',
  },
  // #endregion Document Lists

  // #region Third Party
  {
    name: 'third-party_inspections_report',
    list: '/third-party/inspections/:id/reports',
    descriptions: "Third Party's Inspection Reports",
  },
  {
    name: 'third_party_inspections_document',
    list: '/third-party/inspections/:id/documents',
  },
  {
    name: 'third_party_inspections_download_attachments',
    download: '/inspections/:id/download-documents',
  },
  // #endregion Third Party

  // #region Product Testing
  {
    name: 'product-testing-document',
    list: '/product-testings/:id/documents',
    create: '',
  },
  // #endregion. Product Testing
  // #region Product Testing Resource
  {
    // Download All Attachement in Product=Testing
    name: 'product_testing_download_attachments',
    download: '/product-testings/:id/attachments/download',
  },
  // #endregion Product Testing Resource
  {
    name: 'internal_inspection_documents',
    list: '/buyer/inspections/:id/documents',
  },
  {
    name: 'test_items',
    list: '/test-items/citations',
    create: '/test-items/custom',
  },
  {
    name: 'service-providers',
    list: '/service-providers',
  },
  {
    name: 'certificationType',
    list: '/factory-audits/certificationType',
  },
  {
    name: 'compliance-custom-options',
    list: '/compliances/custom-options',
    create: '/compliances/custom-options',
  },
  {
    name: 'compliance-certificate-type',
    list: '/compliances/certification-types',
    create: '/compliances/certification-types',
  },
  {
    name: 'compliance-service-providers',
    list: '/compliances/service-providers',
    create: '/service-providers',
  },
  {
    name: 'product-compliance-test-data',
    list: '/products/:id/compliance-data/test-data',
  },
  // #region Company
  {
    name: 'company',
    list: '/companies',
    show: '/companies',
  },
  // #endregion
  // #region Product Certificate Generate GCC/CPC
  {
    name: 'product-certificate-gcc-cpc',
    list: '/products/:productId/certificates/:type',
    create: '/products/:productId/certificates/:type',
    edit: '/products/:productId/certificates/:type',
    show: '/products/:productId/certificates/:type',
  },
  {
    name: 'product-certificate-gcc-cpc-latest',
    list: '/products/:productId/certificates/:type/latest-draft',
  },
  {
    name: 'product-certificate-gcc-cpc-preview-publish',
    list: '/products/:productId/certificates/:type/:id/pdf-preview',
    create: '/products/:productId/certificates/:type/:id/publish',
  },
  {
    name: 'factories',
  },
  {
    name: 'inspection-product',
    list: '/inspections/:id/products',
  },
  ...ProductResource,
  ...InspectionResource,
  // #endregion Product Certificate Generate GCC/CPC
].map((resource) => {
  return {
    ...resource,
    meta: {
      ...resource.meta,
      apiPrefix: MICRO_PREFIX,
    },
  };
});
